export default __webpack_public_path__ + "static/media/image5.e9c26a49.jpg";